// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M5.5308642,2.17283951 L9.08641975,2.17283951 C12.9127038,2.17283951 16,
			5.26013575 16,9.08641975 C16,12.9127038 12.9127038,16 9.08641975,16 L7,16 L7,
			12.4444444 L9.08641975,12.4444444 C10.9490246,12.4444444 12.4444444,10.9490246
			12.4444444,9.08641975 C12.4444444,7.22381486 10.9490246,5.72839506 9.08641975,
			5.72839506 L5.5308642,5.72839506 L5.5308642,7.90123457 L0,3.95061728 L5.5308642,
			0 L5.5308642,2.17283951 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Undo.js